// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"e35918bf","638":"2afe089a"}[chunkId] + ".chunk.css";
};